module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Contact")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 grid__padding--left--right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedShield),
      expression: "selectedShield"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedShield = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shieldOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value,
        "textContent": _vm._s(option.text)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-button', {
    attrs: {
      "label": 'Add'
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2 grid__padding--right"
  }, [_c('input', {
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Platform"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-2 grid__padding--left"
  }, [_c('input', {
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Url"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-u-1-3 grid__padding--right"
  }, [_c('input', {
    staticClass: "configurator__input",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Color"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7212e699"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuratorContact.vue
// module id = 68
// module chunks = 0